// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uXeB9","left":"styles_left__23Qay"};